import React, { Component }  from "react";
import { connect } from "react-redux";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faUndoAlt } from "@fortawesome/fontawesome-free-solid";
import { Link } from "react-router-dom";
import MetaTags from 'react-meta-tags';
import * as actions from "../actions";

class ThankYou extends Component {
  constructor(props){
    super(props);
  }
  componentWillUnmount() {
    this.props.resetDrawingStatus();
  }
  render() {
    return (
      <div style={{ maxHeight: "100%" }}>
       <MetaTags>
          <title>Tuck and Rose: Wedding Photostream</title>
        </MetaTags>
        <div
          className="inner-content-sub center-align"
        >
          <img
            style={{
              maxWidth: "100%",
              margin: "0 auto"
            }}
            src={this.props.dataURL}
            alt="thank_you_image"
          />
          <h4 style={{ textAlign: "center" }}>Thank you for sharing!</h4>
          <p>
          Thank you for sharing your photo and thoughts with us. Do note it may not appear immediately, so please rest assured it will be published!
          </p>
          <Link to="/nigoki">
            <div style={{ textAlign: "center", color: "#000" }}>
              <span>Back to Home</span>
              <div className="back_icon_wrapper">
                <FontAwesomeIcon icon={faUndoAlt} size="2x" />
              </div>
            </div>
          </Link>
        </div>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    dataURL: state.drawnImage.dataURL
  };
}
export default connect(mapStateToProps, actions)(ThankYou);



// WEBPACK FOOTER //
// ./src/components/ThankYou.js